module.exports = __webpack_public_path__ + "static/media/image-02-full.3b1876b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-02-full.jpg
// module id = 351
// module chunks = 0